import {FC, useContext, useEffect, useState} from "react";
import { useNavigate, useLocation, matchPath } from "react-router-dom";

import HubHeader from '../components/header';
import GuestTopHeader from "src/components/guestTopHeader";

import { AuthContext } from "../context/authContext";
import { AuthenticatedRoutes, ManufacturerRoutes, PublicRoutes ,ManufacturerRoutesWithoutEOB, AuthenticatedRoutesWithEoB} from "../routes/AppRoutes";
import { AppRoute } from "src/routes/types";
import { MANUFACTURER_ROUTES_BY_REF_TYPE, USER_TYPES } from "src/constants";
import ImportantNoticeModal from "src/components/modals/importantNoticeModal";
// import {USER_TYPES} from "../constants";


const WithHeaderandFooter: FC<{ WrappedComponent: FC }> = ({ WrappedComponent }): JSX.Element => {
  const [showImportantNoticeModal, updateVisibilityOfImportantNoticeModal] = useState<boolean>(false)

  const { isUserAuthorized, isRestoreCalled, userData, isManufacturer, restoreSession } = useContext(AuthContext);
  const navigate = useNavigate();
  const { pathname, search } = useLocation();
  const isSingleSignOn = localStorage.getItem("fromSingleSignOn")


  const navigateToTargetedRoute = (RouteListing: AppRoute[]) => {
    // const indexRoute = RouteListing.find((route) => route.isIndex);
    // const currentRoute = RouteListing.find((route) => {
    //   const firstCheck = route.route.includes(pathname);
    //   if (route.route.includes(":")) {
    //     const checkForRoute = route.route.replace(/:([a-z]+)\/?/gi, "/").replace(/\//g, "");
    //     const checkForPathname = pathname.replace(/[0-9]/g, "").replace(/\//g, "");
    //     const secondCheck = checkForRoute === checkForPathname;
    //     return firstCheck || secondCheck;
    //   } else {
    //     return firstCheck;
    //   }
    // });
     const indexRoute = RouteListing.find((route) => route.isIndex);
    const currentRoute = RouteListing.find((route) =>
      matchPath({ path: route.route, end: false }, pathname)
    );

    if (indexRoute && userData) {
      if (currentRoute) {
         if (userData.ref_type === "rep") {
          if (MANUFACTURER_ROUTES_BY_REF_TYPE.REP.includes(currentRoute.route)) {
            navigate(`/territories/${userData.id}`);
          } 
          else if(!pathname.includes("/territories")) {
            navigate(`/territories/${userData.id}`);
          }
          else{
            navigate(pathname + search)
            }
        } else if (userData.ref_type === "regional_manager") {
          if (MANUFACTURER_ROUTES_BY_REF_TYPE.REGIONAL_MANAGER.includes(currentRoute.route)) {
             navigate(`/regions/${userData.id}`);
          } else if(!pathname.includes("/regions")) {
            navigate(`/regions/${userData.id}`);
          }else{
             navigate(pathname + search)
          }
        } else if (userData.ref_type === "district_manager") {
          if (MANUFACTURER_ROUTES_BY_REF_TYPE.DISTRICT_MANAGER.includes(currentRoute.route)) {
           navigate(`/districts/${userData.id}`);
          } else if(!pathname.includes("/districts")) {
            navigate(`/districts/${userData.id}`)
          }else{
            navigate(pathname + search)
            }
        } else {
          navigate(pathname + search);
        }
      } else {
        navigate(indexRoute.route);
      }
    }
  }

  const checkForAuthentication = () => {
    if (!isUserAuthorized) {
      navigateToTargetedRoute(PublicRoutes);
    } else {
      if (isSingleSignOn) {
        if (isManufacturer) {
          navigateToTargetedRoute(( userData?.eob_button || userData?.ref_type === "fam_rm") ? ManufacturerRoutes : ManufacturerRoutesWithoutEOB);
        } else {
          navigateToTargetedRoute(userData && userData.eob_button ? AuthenticatedRoutesWithEoB : AuthenticatedRoutes);
        }
      } else {
        if (userData?.is_password_changed === false) {
          navigate("/users/createuser");
        } else if (isManufacturer) {
          navigateToTargetedRoute((userData?.eob_button || userData?.ref_type === "fam_rm") ? ManufacturerRoutes : ManufacturerRoutesWithoutEOB);
        } else {
          navigateToTargetedRoute(userData && userData.eob_button ? AuthenticatedRoutesWithEoB : AuthenticatedRoutes);
        }
      }
    }
  }

  useEffect(() => {
    if (isRestoreCalled) {
      checkForAuthentication();
    } else if (!userData) {
      restoreSession();
    } else {
      navigate(pathname + search);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isRestoreCalled, isUserAuthorized]);

  useEffect(() => {
    if (isUserAuthorized && userData && !USER_TYPES.MANUFACTURER.includes(userData.ref_type)) {
      updateVisibilityOfImportantNoticeModal(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUserAuthorized]);




  return (
    <>
      <header className="bg-white sticky-top">
        {!isUserAuthorized ? (
          <GuestTopHeader />
        ) : null}
        <HubHeader />
      </header>
      {/* { <div>{showBanner && !isManufacturer && isUserAuthorized && (
        <div className="alert alert-warning auto-save-banner d-flex align-items-start justify-content-between">
          <div>
            <h4 className="alert-heading mb-2 fs-4">Important Medicare Eligibility Verification Notice</h4>
            <p>
              EXPAREL Support is currently working through updated CMS HETS registration and attestation requirements
              impacting Medicare eligibility verification transactions.
              <br/>
              During this period, Medicare eligibility verification may be temporarily unavailable through our standard
              electronic verification process. While EXPAREL Support continues working to restore full connectivity,
              provider offices may need to verify Medicare eligibility and benefits directly using their existing internal processes.
              <br/>
              Please note that EXPAREL Support can continue supporting commercial and secondary coverage verification
              activities during this time.
              <br/>
              Our team is actively monitoring the situation and working closely with our technology and connectivity
              partners to minimize disruption to patient support services.
              <br/>
              We appreciate your partnership and patience as the industry works through these CMS changes. Please contact our team 
              with any questions.
              <br/>
            </p>
          </div>
          <button type="button" className="btn bi bi-x-lg fs-5 p-0" onClick={handleCloseBanner}></button>
        </div>
      )}</div> } */}
      <WrappedComponent />

      <ImportantNoticeModal show={showImportantNoticeModal} onHide={() => updateVisibilityOfImportantNoticeModal(false)} />

       {/* {mountTawk ? <TawkToMessengerComp /> : null} */}

      {/* <HubFooter /> */}
    </>
  );
}


export default WithHeaderandFooter;
